import { Box, Button, Modal, Stack, Typography } from '@mui/material';
import * as React from 'react';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import { useTranslation } from 'react-i18next';
import CloseIcon from '@mui/icons-material/Close';
import SendIcon from '@mui/icons-material/Send';
import { useNavigate, useParams } from 'react-router';
import { EmployeeMobileRequestsVovClient, RequestResponseWithBuildingDTO } from '../../../ApiOld/Api/ApiServerVov';
import { useMobileApi } from '../../../Api/Mobile/useMobileApi';
import { useCallback, useEffect } from 'react';

export interface IRequestNotificationModalProps {
    open: boolean;
    onClose: () => void;
    title: string;
    body: string;
    requestId?: number | undefined;
}

export default function RequestNotificationModal(props: IRequestNotificationModalProps) {
    const { open, onClose, title, body, requestId } = props;
    const { t } = useTranslation();
    const navigate = useNavigate();
    const params = useParams();
    const { authorizedMobileEmployeeApi } = useMobileApi(EmployeeMobileRequestsVovClient);
    const [request, setRequest] = React.useState<RequestResponseWithBuildingDTO | undefined>();

    const handleClose = useCallback(() => {
        setRequest(undefined);
        onClose();
    }, [onClose]);

    useEffect(() => {
        if (requestId) {
            authorizedMobileEmployeeApi.getRequestDetail(requestId).then((res) => {
                if (res) {
                    setRequest(res.request);
                }
            });
        }
    }, [authorizedMobileEmployeeApi, requestId]);

    return (
        <Modal open={open} onClose={handleClose}>
            <Box sx={{
                background: 'white',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: '90%',
                p: 4,
                borderRadius: 2,
                border: 'none'
            }}>
                <NotificationsActiveIcon sx={{ fontSize: 70, color: '#FFC600' }} />
                <Typography sx={{ fontSize: 20, fontWeight: 'bold', color: '#FFC600' }}>{title}</Typography>
                <Typography sx={{ fontSize: 12, textAlign: 'center' }}>{body}</Typography>
                <Stack direction={'row'} spacing={2} justifyContent='space-between' sx={{ mt: 2 }}>
                    <Button size='small' variant='outlined' startIcon={<CloseIcon />} onClick={handleClose}>{t('close')}</Button>
                    {request && <Button size='small' variant='contained' endIcon={<SendIcon />} onClick={() => {
                        handleClose();
                        navigate('/' + params['lang']! + '/' + params['domain']! + '/employee/request-detail', { state: { request: request } });
                    }}>{t('Redirect')}</Button>}
                </Stack>
            </Box>
        </Modal>
    );
}